export { default } from './BlockIdPlugin';
export * from './BlockIdPlugin';
